var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Hardware / keyboard arrow_down"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_8285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 12,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Round",
    d: "M8.12496 9.26418L12.005 13.1442L15.885 9.26418C16.275 8.87418 16.905 8.87418 17.295 9.26418C17.685 9.65418 17.685 10.2842 17.295 10.6742L12.705 15.2642C12.315 15.6542 11.685 15.6542 11.295 15.2642L6.70496 10.6742C6.51771 10.4873 6.41248 10.2337 6.41248 9.96918C6.41248 9.70466 6.51771 9.45101 6.70496 9.26418C7.09496 8.88418 7.73496 8.87418 8.12496 9.26418Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_8285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color Fill",
    y: 0.264648,
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRounded);
export default __webpack_public_path__ + "static/media/arrow_down_rounded.175de72e7c33eb21f209902ed228d146.svg";
export { ForwardRef as ReactComponent };